







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Laporan from "@/services/Laporan";
import { LoginReportResponse } from "@/services/Laporan";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  beforeRouteEnter(to, from, next) {
    if (userModule.user.role?.id <= 2) {
      next();
    } else {
      appModule.sendErrorAlert("Halaman ini tidak bisa diakses...");

      next("/404");
    }
  },
  components: {
    //
  }
})
export default class LoginReportPage extends Vue {
  rptData: LoginReportResponse = null;
  loading = false;
  options: {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
  } = {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["attempted_at"],
    sortDesc: [true]
  };
  searchStr = null;
  dates: string[] = [];
  showDate = false;
  statSuccess = null;

  get statSuccessOpt() {
    return [
      { id: null, title: "Semua" },
      { id: 1, title: "Berhasil" },
      { id: 0, title: "Gagal" }
    ];
  }

  get listItems() {
    return this.rptData
      ? this.rptData.data.map((item, index) => ({
          ...item,
          attempted_at: moment(item.attempted_at).format("YYYY-MM-DD HH:mm:ss"),
          idx: this.rptData.from + index
        }))
      : [];
  }

  get listItemsTotal() {
    return this.rptData ? this.rptData.total : 0;
  }

  get headers() {
    const headers = [
      { text: "#", value: "idx" },
      { text: "IP Addr.", value: "ip" },
      { text: "Username", value: "username" },
      { text: "Activity", value: "activity" },
      { text: "Status", value: "status" },
      { text: "Nama User", value: "user.nama" },
      { text: "Attempted At", value: "attempted_at" }
    ];

    return headers;
  }

  get dateRangeText() {
    return this.dates.join(" ~ ");
  }

  @Watch("options", { deep: true })
  onChangedOptions(val) {
    this.getReportData();
  }

  getReportData() {
    const { page, itemsPerPage, sortBy, sortDesc } = this.options;
    const params = {
      page: page,
      per_page: itemsPerPage,
      sort_by: sortBy[0],
      sort_desc: sortDesc[0],
      search: this.searchStr,
      date: this.dates,
      success: this.statSuccess !== null ? this.statSuccess : undefined
    };

    if (!this.loading) {
      this.loading = true;

      Laporan.getLoginReport(params)
        .then(resp => {
          this.rptData = resp;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  getResetedReportData() {
    this.options.page = 1;
    this.options.itemsPerPage = 25;
    this.getReportData();
  }

  onRowClick(item: null) {
    // event on row click
  }
}
